import React, { useState } from "react";
import { Link } from "react-scroll";
import { makeStyles } from "@mui/styles";
import Paper from "@mui/material/Paper";
import { Router } from "react-router-dom";
import {
	AppBar,
	Toolbar,
	List,
	ListItem,
	ListItemText,
} from "@mui/material";

import { createBrowserHistory } from "history";

const history = createBrowserHistory();

const useStyles = makeStyles({
	root: {
		flexGrow: 1,
	},
	navBar: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		transition: "background-color 0.5s ease-in-out",
		height: "5%",
	},
	navItems: {
		display: "flex",
		flexDirection: "row",
		paddingLeft: "30px",
		textTransform: "uppercase",
	},
	navActiveItem: {
		color: "rgb(101, 58, 150)",
		borderRadius: 25,
	},
});

export const NavbarDesktop: React.FC = () => {
	const classes = useStyles();
	const [active, setActive] = useState(false);

	const handleState = (to: any) => {
		if (to === "home") {
			setActive(true);
			history.push("/");
		} else {
			setActive(false);
			history.push(`/${to}`);
		}
	};

	return (
		<Paper className={classes.root}>
			<AppBar
				elevation={active ? 0 : 5}
				className={classes.navBar}
				style={
					active
						? { backgroundColor: "#dedede" }
						: { backgroundColor: "#e3e3e3" }
				}
			>
				<Toolbar>
					<Router history={history}>
						<List
							className={classes.navItems}
							component="nav"
							style={active ? { color: "#000000" } : { color: "#4a4a4a" }}
						>
							<Link
								activeClass={classes.navActiveItem}
								onSetActive={handleState}
								to="home"
								spy={true}
								smooth={true}
								duration={500}
							>
								<ListItem
									sx={{
										borderRadius: 2,
										px: 1.5,
										userSelect: 'none',
										WebkitUserSelect: 'none',
										cursor: 'pointer',
										transition: 'all 0.2s ease-in-out',
										'&:hover': {
											backgroundColor: 'rgba(101, 58, 150, 0.08)',
											color: '#653A96',
										},
									}}
								>
									<ListItemText primary="Home" />
								</ListItem>
							</Link>

							<Link
								activeClass={classes.navActiveItem}
								onSetActive={handleState}
								to="about"
								spy={true}
								smooth={true}
								duration={500}
							>
								<ListItem
									sx={{
										borderRadius: 2,
										px: 1.5,
										userSelect: 'none',
										WebkitUserSelect: 'none',
										cursor: 'pointer',
										transition: 'all 0.2s ease-in-out',
										'&:hover': {
											backgroundColor: 'rgba(101, 58, 150, 0.08)',
											color: '#653A96',
										},
									}}
								>
									<ListItemText primary="About" />
								</ListItem>
							</Link>
							<Link
								activeClass={classes.navActiveItem}
								onSetActive={handleState}
								to="services"
								spy={true}
								smooth={true}
								duration={500}
							>
								<ListItem
									sx={{
										borderRadius: 2,
										px: 1.5,
										userSelect: 'none',
										WebkitUserSelect: 'none',
										cursor: 'pointer',
										transition: 'all 0.2s ease-in-out',
										'&:hover': {
											backgroundColor: 'rgba(101, 58, 150, 0.08)',
											color: '#653A96',
										},
									}}
								>
									<ListItemText primary="Services" />
								</ListItem>
							</Link>
							<Link
								activeClass={classes.navActiveItem}
								onSetActive={handleState}
								to="gallery"
								spy={true}
								smooth={true}
								duration={500}
							>
								<ListItem
									sx={{
										borderRadius: 2,
										px: 1.5,
										userSelect: 'none',
										WebkitUserSelect: 'none',
										cursor: 'pointer',
										transition: 'all 0.2s ease-in-out',
										'&:hover': {
											backgroundColor: 'rgba(101, 58, 150, 0.08)',
											color: '#653A96',
										},
									}}
								>
									<ListItemText primary="Gallery" />
								</ListItem>
							</Link>
							<Link
								activeClass={classes.navActiveItem}
								onSetActive={handleState}
								to="contact"
								spy={true}
								smooth={true}
								duration={500}
							>
								<ListItem
									sx={{
										borderRadius: 2,
										px: 1.5,
										userSelect: 'none',
										WebkitUserSelect: 'none',
										cursor: 'pointer',
										transition: 'all 0.2s ease-in-out',
										'&:hover': {
											backgroundColor: 'rgba(101, 58, 150, 0.08)',
											color: '#653A96',
										},
									}}
								>
									<ListItemText primary="Contact" />
								</ListItem>
							</Link>
						</List>
					</Router>
				</Toolbar>
			</AppBar>
		</Paper>
	);
};
